<template>
  <div class="radio-group-container form-main">
    <div class="radio-group-inner">
      <div v-for="formField in formData.options" v-bind:key="formField.id">
        <label
          :class="{ checked: formData.selected == formField }"
          class="radio-group is-button"
        >
          <span class="ml-2">{{ formField }}</span>
          <input
            type="radio"
            name="tab-1"
            :value="formField"
            v-model="formData.selected"
          />
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RadioGroup",
  props: {
    formData: Object,
  },
};
</script>